import React from 'react';
import ReactScrollAnimation from 'react-animate-on-scroll';

const ScrollAnimation = ({ children }) => {
  return (
    <ReactScrollAnimation animateIn="fadeIn" animateOnce>
      {children}
    </ReactScrollAnimation>
  );
};

export default ScrollAnimation;



// WEBPACK FOOTER //
// ./src/components/ScrollAnimation.js